import React from 'react';
import { Link } from 'react-router-dom';

export interface RelatedGuide {
  to: string;
  title: string;
  text: string;
}

// « À lire aussi » : liens entre les pages d'un même sujet (maillage interne)
const RelatedGuides: React.FC<{ id?: string; title?: string; items: RelatedGuide[] }> = ({
  id,
  title = 'À lire aussi',
  items,
}) => (
  <section id={id} className="mg-related" aria-labelledby={id ? `${id}-title` : undefined}>
    <h2 id={id ? `${id}-title` : undefined}>{title}</h2>
    <div className="mg-related-grid">
      {items.map((item) => (
        <Link key={item.to} to={item.to} className="mg-related-card">
          <b>{item.title}</b>
          <span>{item.text}</span>
          <span className="mg-related-more" aria-hidden="true">
            Lire →
          </span>
        </Link>
      ))}
    </div>
  </section>
);

export default RelatedGuides;
